import { useRef as r, useState as t, useEffect as n, useDebugValue as u } from "react";

var useState = function useState(e) {
  var c = r(!0),
      o = t(e),
      a = o[0],
      f = o[1];
  return n(function () {
    return function () {
      c.current = !1;
    };
  }, []), u(a), [a, function (r) {
    c.current && f(r);
  }];
};

export default useState;